<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">
    <div class="hpanel no-margins" >
      <template v-if="companies.length !== 0">

        <div class="panel-heading hbuilt">

          <div class="row">
            <div class="col-xs-6 text-center">
              Best Companies: <span class="font-extra-bold m-t-xl m-b-xs text-info" >{{bestExperts}}</span>
            </div>
            <div class="col-xs-6 text-center">
              Total Companies estimate: <span class="font-extra-bold m-t-xl m-b-xs" style="">{{nbEstimateCompanies}}</span>
            </div>
          </div>
        </div>

        <div class="panel-body no-padding ">
          <table style="width: 100%">
            <tr style="height: 25px">
              <th class="col-md-5 col-xs-5">
                <table class="table" style="width: 100%">
                  <td class="col-xs-6 col-md-6" style="vertical-align: middle">
                    <span role="button" @click="changeSort('affiliation')">Company <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                  <td class="col-xs-6 col-md-6 text-center" style="vertical-align: middle">
                    <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                </table>
              </th>
              <th class="col-md-3 col-xs-3"><span role="button" @click="changeSort('source')">Source <i style="padding-left: 15px" class="fa fa-sort"></i></span></th>
              <th class="col-md-2 col-xs-2 text-center"><span role="button" @click="changeSort('score')">Score <i style="padding-left: 15px" class="fa fa-sort"></i></span></th>
              <th class="col-md-2 col-xs-2 text-center"><span>Action</span></th>
            </tr>
          </table>
          <div v-if="companies.length !== 0" >
            <div v-for="(company, key) in companies" v-if="company && key < context.nbItemsDisplay" :key="key + '-' + company.authorID" class="clearfix ">
              <template v-if="$user.isSe() && company.expertSource === 'TECHNICAL EDISON'">
                <company-s-e-top v-model="companies[key]" class="" :context="context" :key="key + '-' + company.authorID"/>
                <div class="col-xs-12 collapse" :id="'collapse-'+ company.authorID" style="padding: 20px" >
                  <documents-s-e-company v-model="companies[key].docs" :author="company"
                                         :pubDateSelected="context.pubDateSelected" :context="context"/>
                </div>
              </template>
              <template v-else>
                <company-top v-model="companies[key]" class="" :context="context" :key="key + '-' + company.authorID"/>
                <div class="col-xs-12 collapse" :id="'collapse-'+ company.authorID" style="padding: 20px" >
                  <documents-company v-model="companies[key].docs" :author="company"
                                     :pubDateSelected="context.pubDateSelected" :context="context"/>
                </div>
              </template>
            </div>

            <div class="text-center" style="padding: 25px" v-if="companies.length > context.nbItemsDisplay">
              <button class="btn btn-primary btn-xs" :class="companies.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="companies.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CompanyTop from '../documents/CompanyTop'
import DocumentsCompany from '../documents/DocumentsCompany'
import CompanySETop from '../documents/CompanySETop'
import DocumentsSECompany from '../documents/DocumentsSECompany'

export default {
  components: {
    DocumentsSECompany,
    CompanySETop,
    DocumentsCompany,
    CompanyTop
  },
  props: ['context', 'value', 'nbEstimateCompanies', 'nbCompanies', 'listType', 'changeSort'],
  name: 'ListCompaniesResults',
  watch: {
    value: function (val) {
      this.companies = val
    }
  },
  data () {
    return {
      companies: null
    }
  },
  computed: {
    bestExperts: function () {
      return this.nbCompanies
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })
  },
  beforeMount () {
    this.companies = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListCompanies/ListCompaniesResults.vue